<p-dialog appDialogoPadrao="pi pi-wallet" descricao="Escolha a conta contábil na lista." [header]="header()" [visible]="visivel()" (visibleChange)="$event ? null : fechar()" [style]="{ width: '760px', maxWidth: '96vw' }" [closeOnEscape]="true">
    <div class="conta-modal-body">
        @if (buscando()) {
            <div class="flex items-center justify-center gap-2 py-10 text-surface-500">
                <i class="pi pi-spin pi-spinner text-xl"></i>
                <span class="text-sm">Carregando plano de contas...</span>
            </div>
        } @else {
            <p-tree [value]="contaTree()" [filter]="true" filterMode="lenient" filterPlaceholder="Pesquisar por código ou descrição..." selectionMode="single" (onNodeSelect)="onNodeSelect($event)" styleClass="conta-modal-tree w-full">
                <ng-template pTemplate="default" let-node>
                    <div class="tree-node-row">
                        <code class="tree-node-code">{{ node.data?.id }}</code>
                        <span class="tree-node-desc">{{ node.data?.descricao }}</span>
                    </div>
                </ng-template>
            </p-tree>
            @if (contaTree().length === 0) {
                <div class="flex flex-col items-center gap-2 py-10 text-surface-400">
                    <i class="pi pi-inbox text-3xl"></i>
                    <span class="text-sm">Nenhuma conta encontrada.</span>
                </div>
            }
        }
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Cancelar" severity="secondary" [outlined]="true" (click)="fechar()" />
    </ng-template>
</p-dialog>
